export default function downloadBlob(blob: Blob, file: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', file)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
